import { Component } from 'react';
import PropTypes from 'prop-types';
import withSizes from 'react-sizes';

const mapSizesToProps = ({ width }) => ({
  isDesktop: width > 1024,
  isTablet: width >= 768 && width < 1024,
  isMobile: width < 768
});

@withSizes(mapSizesToProps)
class DeviceTypeComponent extends Component {
  static propTypes = {
    isDesktop: PropTypes.bool,
    isTablet: PropTypes.bool,
    isMobile: PropTypes.bool,
    desktop: PropTypes.node,
    tablet: PropTypes.node,
    mobile: PropTypes.node,
  };

  render() {
    const { mobile, tablet, desktop, isMobile, isTablet, isDesktop } = this.props;

    return (
      isDesktop && desktop || isTablet && tablet || isMobile && mobile
    );
  }
}

export default DeviceTypeComponent;
